import { Gift } from "lucide-react";
import { motion } from "framer-motion";
import { offerText, offerNote } from "../../data/siteData";

export const OfferBanner = ({ testId = "offer-banner" }) => (
  <section className="relative overflow-hidden bg-gradient-to-r from-[#C85A32] via-[#B24E2A] to-[#8E3A1E]" data-testid={testId}>
    <div className="offer-shine" aria-hidden="true" />
    <div className="container-site relative flex flex-col md:flex-row md:items-center gap-5 md:gap-8 py-8 sm:py-10">
      <motion.div
        initial={{ rotate: -12, scale: 0.8 }}
        whileInView={{ rotate: 0, scale: 1 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ type: "spring", stiffness: 160, damping: 12 }}
        className="shrink-0 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#F7F4EB] text-[#B24E2A] flex items-center justify-center shadow-xl"
      >
        <Gift className="w-7 h-7 sm:w-8 sm:h-8" strokeWidth={1.6} />
      </motion.div>
      <div>
        <p className="font-display font-semibold text-2xl sm:text-3xl lg:text-4xl leading-tight text-[#F7F4EB] tracking-tight" data-testid={`${testId}-text`}>{offerText}</p>
        <p className="mt-2 text-sm text-[#F7F4EB]/90">{offerNote}</p>
      </div>
    </div>
  </section>
);

export const OfferInline = ({ count, testId = "offer-inline" }) => (
  <div className="flex items-start gap-3 rounded-2xl border border-[#C85A32]/50 bg-[#C85A32]/15 p-4" data-testid={testId}>
    <Gift className="w-5 h-5 shrink-0 mt-0.5 text-[#F0A385]" />
    <div>
      <p className="text-sm font-semibold text-[#F7F4EB] tracking-wide">{offerText}</p>
      {count !== undefined && count > 0 ? (
        <p className="mt-1 text-sm text-[#F0A385]" data-testid={`${testId}-count`}>
          {count} canette{count > 1 ? "s" : ""} offerte{count > 1 ? "s" : ""} avec votre commande
        </p>
      ) : (
        <p className="mt-1 text-xs text-[#D6CFC0]">{offerNote}</p>
      )}
    </div>
  </div>
);
